<template>
  <div
    style="overflow:hidden; display:flex; align-items:center; justify-content:center; position:relative; height;100vh; width:100%;"
  >
    <slot></slot>
    <transition mode="out-in" enter-active-class="fadeIn2" leave-active-class="fadeOut">
      <div
        v-if="!isMobile && loaded"
        style="position:fixed;top:0;left:0;overflow:hidden;height:100vh;width:100vw; display:flex; align-items:center; justify-content:center; align-items:flex-end;"
      >
        <video playsinline class="animated-slow" autoplay muted loop id="myVideo">
          <source src="../../img/cut_throat_city.mp4" type="video/mp4" />
        </video>
      </div>
    </transition>
    <div v-if="true" class="background" :class="{'active': (activePage != 'main')}" id="three"></div>
  </div>
</template>
<script>
import * as THREE from "three";
import OrbitControls from "three-orbitcontrols";
import { TrackballControls } from "three/examples/jsm/controls/TrackballControls.js";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { EXRLoader } from "three/examples/jsm/loaders/EXRLoader.js";
import { PMREMGenerator } from "three/examples/jsm/pmrem/PMREMGenerator.js";
import { PMREMCubeUVPacker } from "three/examples/jsm/pmrem/PMREMCubeUVPacker.js";

export default {
  name: "Three",
  props: ["activePage"],
  data() {
    return {
      scene: "",
      renderer: "",
      camera: "",
      controls: "",
      object: "",
      env: "",
      obj_opacity: 0,
      color_lights: 0,
      xRate: 0.01,
      yRate: 0.0005,
      loop: 0,
      stopLoop: 0.05,
      mouse: false,
      loaded: false
    };
  },
  mounted() {
    setTimeout(() => {
      this.loaded = true;
    }, 2000);
    this.init();
    window.addEventListener(
      "mousedown",
      () => {
        this.mouse = true;
        console.log(this.mouse);
      },
      true
    );
    window.addEventListener(
      "mouseup",
      () => {
        this.mouse = false;
        console.log(this.mouse);
      },
      true
    );
  },
  methods: {
    onWindowResize() {
      this.camera.aspect = window.innerWidth / window.innerHeight;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize(window.innerWidth, window.innerHeight);
    },
    init() {
      var params = {
        envMap: "EXR",
        roughness: 0.0,
        metalness: 0.0,
        exposure: 1.0,
        debug: false
      };

      var container, stats;
      var camera, scene, renderer, controls;
      var torusMesh, planeMesh;
      var pngCubeRenderTarget, exrCubeRenderTarget;
      var pngBackground, exrBackground;
      this.scene = new THREE.Scene();
      this.camera = new THREE.PerspectiveCamera(
        50,
        window.innerWidth / window.innerHeight,
        0.001,
        1000
      );

      this.renderer = new THREE.WebGLRenderer({
        antialias: true,
        alpha: true
      });
      this.renderer.gammaInput = false;
      this.renderer.gammaOutput = true;
      this.renderer.gammaFactor = 2.2;

      this.renderer.setClearColor(0x000000, 0.0);
      this.renderer.setSize(window.innerWidth, window.innerHeight);
      const bod = document.getElementById("three");
      let elm = bod.appendChild(this.renderer.domElement);
      elm.style.position = "relative";
      elm.style.zIndex = 1;

      var geometry = new THREE.BoxGeometry(1, 1, 1);
      var material = new THREE.MeshBasicMaterial({ color: 0x00ff00 });
      var cube = new THREE.Mesh(geometry, material);
      //this.scene.add(cube);

      this.camera.position.z = 2;
      this.camera.position.x = 0;
      this.camera.position.y = 0;

      //   var ambientLight = new THREE.AmbientLight(0xffffff, 0.1);
      //   this.scene.add(ambientLight);

      var directionalLight = new THREE.DirectionalLight(0xffffff, 0.2);
      directionalLight.castShadow = true;
      directionalLight.position.set(0, 0, 0);

      var pinkLight = new THREE.DirectionalLight(0xff96dc, 0);
      pinkLight.castShadow = true;
      pinkLight.position.set(10, 0, 15);
      //this.scene.add(pinkLight);

      var blueLight = new THREE.DirectionalLight(0x01c2fe, 0);
      blueLight.castShadow = true;
      blueLight.position.set(-10, 0, 15);
      // this.scene.add(blueLight);

      //   var directionalLight4 = new THREE.DirectionalLight(0xffffff, 0.2);
      //   directionalLight4.castShadow = true;
      //   directionalLight4.position.set(0, 0, 15);
      //   this.scene.add(directionalLight4);

      //   var directionalLight5 = new THREE.DirectionalLight(0xffffff, 0.2);
      //   directionalLight5.castShadow = true;
      //   directionalLight5.position.set(12, 4, 15);
      //   this.scene.add(directionalLight5);

      //   var directionalLight2 = new THREE.DirectionalLight(0x8200c9);
      //   directionalLight2.castShadow = true;
      //   directionalLight2.position.set(10, 0, 15);
      //   this.scene.add(directionalLight2);

      //   var directionalLight3 = new THREE.DirectionalLight(0x11e8bb);
      //   directionalLight3.castShadow = true;
      //   directionalLight3.position.set(-10, 0, 15);
      //   this.scene.add(directionalLight3);

      //   var pointLight = new THREE.PointLight(0xffffff, 1);
      //   pointLight.position.set(0, 0, 0);
      this.camera.add(directionalLight);
      this.scene.add(this.camera);
      controls = new TrackballControls(this.camera, this.renderer.domElement);

      controls.rotateSpeed = 4.0;
      controls.zoomSpeed = 1.2;
      controls.panSpeed = 0.8;

      controls.staticMoving = true;
      controls.dynamicDampingFactor = 0.3;

      controls.keys = [65, 83, 68];

      //controls.addEventListener( 'change', render );
      // this.controls.minDistance = 2;
      // this.controls.maxDistance = 5;

      //   var loader = new THREE.OBJLoader();
      //   loader.load("cbobj.obj", object => {
      //     this.scene.add(object);
      //   });

      new EXRLoader()
        .setDataType(THREE.FloatType)
        .load("piz_compressed.exr", texture => {
          var options = {
            generateMipmaps: false,
            minFilter: THREE.LinearFilter,
            magFilter: THREE.LinearFilter
          };

          exrBackground = new THREE.WebGLRenderTargetCube(
            512,
            512,
            options
          ).fromEquirectangularTexture(this.renderer, texture);

          var pmremGenerator = new PMREMGenerator(exrBackground.texture);
          pmremGenerator.update(this.renderer);

          var pmremCubeUVPacker = new PMREMCubeUVPacker(
            pmremGenerator.cubeLods
          );
          pmremCubeUVPacker.update(this.renderer);

          exrCubeRenderTarget = pmremCubeUVPacker.CubeUVRenderTarget;

          texture.dispose();
          pmremGenerator.dispose();
          pmremCubeUVPacker.dispose();
          // this.scene.background = exrBackground;
        });
      var loader = new GLTFLoader();
      loader.load(
        "rumble2.glb",
        gltf => {
          this.object = gltf.scene;
          gltf.scene.scale.set(0.02, 0.02, 0.02);
          gltf.scene.position.x = 0; //Position (x = right+ left-)
          gltf.scene.position.y = 0.2; //Position (y = up+, down-)
          gltf.scene.position.z = -0.02; //Position (z = front +, back-)
          this.object.opacity = 0;
          this.object.traverse(o => {
            if (o.isMesh) {
              //   if (o.material.name == "Material.001") {
              //     return;
              //   }
              o.material.transparent = true;
              o.material.opacity = 0;
              o.material.envMap = exrCubeRenderTarget
                ? exrCubeRenderTarget.texture
                : null;
            }
          });
          this.scene.add(this.object);
        },
        progress => {
          this.$emit("setProgress", progress);
        },
        function(error) {
          console.error(error);
        }
      );

      loader.load(
        "rumbleriot.glb",
        gltf => {
          this.object2 = gltf.scene;
          gltf.scene.scale.set(0.02, 0.02, 0.01);
          gltf.scene.position.x = 0; //Position (x = right+ left-)
          gltf.scene.position.y = -0.4; //Position (y = up+, down-)
          gltf.scene.position.z = 0; //Position (z = front +, back-)
          this.object2.opacity = 0;
          this.object2.traverse(o => {
            if (o.isMesh) {
              //   if (o.material.name == "Material.001") {
              //     return;
              //   }
              o.material.transparent = true;
              o.material.opacity = 0;
              o.material.envMap = exrCubeRenderTarget
                ? exrCubeRenderTarget.texture
                : null;
            }
          });
          this.scene.add(this.object2);
        },
        progress => {
          this.$emit("setProgress", progress);
        },
        function(error) {
          console.error(error);
        }
      );
      //   var mtlLoader = new THREE.MTLLoader();
      //   mtlLoader.load("obj/testobj2.mtl", materials => {
      //     materials.preload();

      //     var objLoader = new THREE.OBJLoader();
      //     //objLoader.setPath("obj");
      //     objLoader.setMaterials(materials);

      //     objLoader.load("obj/testobj2.obj", object => {
      //       this.scene.add(object);
      //     });
      //   });

      var animate = () => {
        requestAnimationFrame(animate);
        if (this.object != "") {
          if (this.activePage != "main") {
            if (this.loop < 0.05) {
              this.loop += 0.001;
              this.xRate = this.loop;
              this.yRate = this.loop;
            } else {
              if (this.stopLoop > 0.001) {
                this.yRate = this.stopLoop;
                this.xRate = this.stopLoop;
                this.stopLoop -= 0.001;
              }
            }
          } else {
            this.stopLoop = 0.05;
            this.loop = 0;
          }
          if (!this.mouse) {
            this.object.rotation.y += this.xRate;
            this.object2.rotation.y += this.xRate;

            //this.object.rotation.x += this.yRate;
          }

          if (this.obj_opacity <= 1) {
            this.obj_opacity += 0.005;
            this.object.traverse(o => {
              if (o.isMesh) {
                if (o.material.name == "Material.001") {
                  if (this.obj_opacity < 0.39) {
                    o.material.opacity += 0.005;
                  }
                } else {
                  o.material.opacity += 0.005;
                }
              }
            });
            this.object2.traverse(o => {
              if (o.isMesh) {
                if (o.material.name == "Material.001") {
                  if (this.obj_opacity < 0.39) {
                    o.material.opacity += 0.005;
                  }
                } else {
                  o.material.opacity += 0.005;
                }
              }
            });
          } else if (this.obj_opacity > 1) {
            this.object.traverse(o => {
              if (o.isMesh) {
                if (o.material.name == "Material.001") {
                  return;
                }
                o.material.transparent = false;
              }
            });
            this.object2.traverse(o => {
              if (o.isMesh) {
                if (o.material.name == "Material.001") {
                  return;
                }
                o.material.transparent = false;
              }
            });
          }

          if (this.activePage == "main") {
            // animate in blue/pink lights on state change
            if (this.color_lights > 0) {
              pinkLight.intensity = this.color_lights;
              blueLight.intensity = this.color_lights;

              this.color_lights = this.color_lights - 0.01;
            } else {
              this.color_lights = 0;
            }
          } else {
            if (this.color_lights < 1) {
              pinkLight.intensity = this.color_lights;
              blueLight.intensity = this.color_lights;

              this.color_lights += 0.01;
            } else {
              this.color_lights = 1;
            }
          }
        }

        // cube.rotation.x += 0.0;
        // cube.rotation.y += 0.01;
        controls.update();
        this.renderer.toneMappingExposure = 10;
        this.renderer.render(this.scene, this.camera);
      };

      animate();
      window.addEventListener("resize", this.onWindowResize, false);
    }
  },
  computed: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    width() {
      return window.innerWidth;
    },
    height() {
      return window.innerHeight;
    }
  }
};
</script>
<style>
.placeholder {
  z-index: 0;
  opacity: 0.2;
  min-height: 140%;
  top: 0;
  max-width: 500%;
  width: 500%;
}

#myVideo {
  z-index: 0;
  opacity: 0.2;
  min-height: 100%;
  top: 0;
  max-width: 500%;
  width: 500%;
}
.topbtns {
  height: 60px;
}
.background {
  transition: all 1s ease;
  position: relative;
  z-index: 0;

  /* background: radial-gradient(#1a1a1a, #000); */
  background: url("https://conductorproductions.com/wp-content/plugins/revslider/public/assets/assets/gridtile_3x3.png");
  background-repeat: repeat;
}
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: height, opacity;
  transition-timing-function: ease;
  overflow: hidden;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
/* .background::before {
  content: "";
  position: absolute;
  height: 100vh;
  width: 100vw;
  opacity: 1;
  z-index: 0;
  transition: all 1s ease;
  background: radial-gradient(#1a1a1a, #000);
}

.background.active::before {
  opacity: 0;
} */
</style>